// Exporting an array of languages
const Languages = ["english", "spanish"];

export default Languages;
